export const translationConfig = {
  common: ['Common.GameSorts', 'Feature.GamePage', 'Feature.GameDetails', 'Feature.ContactUpsell'],
  feature: 'Feature.PlacesList'
};

export default translationConfig;
